import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { UtilsService } from '../../../Services/utils.service';
import { GuideStep } from '../../../Interfaces/interfaces';
import { FormsModule } from '@angular/forms';

interface Card {
  backgroundColor: string;
  ribbonGradient: string;
  buttonGradient: string;
  title: string;
  description: string;
  buttonText: string;
  maxWinText: string;
  upToText: string;
  chanceText: string;
  cardImage: string;
  iconImage: string;
}

@Component({
  selector: 'app-sectrech-card-list',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './sectrech-card-list.component.html',
  styleUrls: ['./sectrech-card-list.component.scss'],
})
export class SectrechCardListComponent implements OnInit {
  // activeTab: ActiveTabType = 'All';
  showModal = false;
  selectedGame: any;
  score = '';
  accountType = '';
  selectedPaymentMethod: 'wallet' | 'withdraw' = 'wallet';
  startDate: string | null = null;
  endDate: string | null = null;
  viewMode: 'grid' | 'table' = 'grid';
  // plusIcon = faPlus;
  //infoIcon = faCircleInfo;
  showDateFilter: boolean = false;
  dropdownOpen: boolean = false;
  searchTerm: string = '';
  @Input() isHomePage: boolean = true;

  constructor(
    private router: Router,
    private _route: ActivatedRoute,
    private utils: UtilsService
  ) { }
  isLandingPage: boolean = true;
  isDashboardPage: boolean = true;
  isScratchCardPage: boolean = true;

  ngOnInit() {
    this.scrollToTopSmooth();
    this.isLandingPage = this.router.url === '/';
    this.isDashboardPage = this.router.url === '/dashboard/home';
    this.isScratchCardPage = this.router.url === '/dashboard/SectrechCards';

    // this.isDashboardPage = this.router.url.startsWith('/dashboard');

    if (this.isDashboardPage) {
      this.scratchCards = this.scratchCards.slice(0, 3);
    } else if (this.isLandingPage) {
      this.scratchCards = this.scratchCards.slice(0, 3);
    } else {
      this.scratchCards = this.scratchCards;
    }
  }

  get token() {
    return this.utils.getItem('token');
  }
  goToBuyNow(cardData: any) {
    if (this.token && this.token != null) {
      const encodedData = encodeURIComponent(JSON.stringify(cardData));
      this.router.navigate(['/dashboard/buy-now', encodedData]);
    } else {
      this.router.navigate(['/login'], {
        queryParams: { redirectUrl: '/dashboard/SectrechCards' },
      });
    }
  }

  get isToken(): boolean {
    return !!localStorage.getItem('token'); // returns true if token exists, false otherwise
  }

  onStartDateChange(date: string) {
    if (this.endDate && new Date(this.endDate) < new Date(date)) {
      this.endDate = null;
    }
  }
  resetDates() {
    this.startDate = null;
    this.endDate = null;
    // this.GetAllGames(true);
  }

  showGuide() {
    const steps: GuideStep[] = [
      {
        imageUrl: '/Images/Scratch-Card/Scratch-Card.png',

        // imageUrlLg: '/Images/user-manual/scratch-cards/card-1.png',
        alt: 'scratch card',
      },
    ];

    this.utils.open(steps, 0, {
      title: 'Scratch Card Guide',
      imageOnly: true,
    });
  }

  cards = [
    {
      ticketprice: 5,
      backgroundColor: '#062b35',
      ribbonGradient: 'from-[#0c3b4a] to-[#12485c]',
      buttonGradient: 'from-[#70e1f5] to-[#536976]',
      title: 'Scratch and Win',
      mainTitle: 'Exciting Scratch Cards',
      description:
        'Get ready to uncover incredible prizes! Our scratch card section is the perfect place to test your luck and see if fortune is on your side.',
      buttonText: 'Buy Now!',
      maxWinText: '$200',
      upToText: 'Up to',
      chanceText: 'Chance to Win',
      cardImage: '/scratchcard/scratch1.png',
      iconImage: '/scratchcard/scratch1.png',
    },
    {
      ticketprice: 10,
      backgroundColor: '#231438',
      ribbonGradient: 'from-[#3A1F5C] to-[#5A3C88]',
      buttonGradient: 'from-[#70e1f5] to-[#536976]',
      title: 'Daily Jackpot',
      mainTitle: 'Daily Jackpot Fun',
      description:
        'Try your luck every day! Scratch your way to amazing prizes and see if you are the lucky winner.',
      buttonText: 'Buy Now!',
      maxWinText: '$500',
      upToText: 'Up to',
      chanceText: 'Chance to Win',
      cardImage: '/scratchcard/scratch2.png',
      iconImage: '/scratchcard/scratch2.png',
    },
    {
      ticketprice: 15,
      backgroundColor: '#315994',
      ribbonGradient: 'from-[#1F3B66] to-[#223d72]',
      buttonGradient: 'from-[#70e1f5] to-[#536976]',
      title: 'Mega Prize',
      mainTitle: 'Mega Rewards',
      description:
        'Step into the world of mega prizes! Every scratch could bring you closer to the ultimate reward.',
      buttonText: 'Buy Now!',
      maxWinText: '$1000',
      upToText: 'Up to',
      chanceText: 'Chance to Win',
      cardImage: '/scratchcard/scratch3.png',
      iconImage: '/scratchcard/scratch3.png',
    },
    // Add more cards as needed
  ];

  card = {
    backgroundColor: '#062b35', // Card background color
    ribbonGradient: 'from-[#0c3b4a] to-[#12485c]', // Ribbon gradient
    buttonGradient: 'from-[#70e1f5] to-[#536976]', // Button gradient
    title: 'Scratch and Win',
    description:
      'Get ready to uncover incredible prizes! Our scratch card section is the perfect place to test your luck and see if fortune is on your side.',
    buttonText: 'Buy Now!',
    maxWinText: '$200',
    upToText: 'Up to',
    chanceText: 'Chance to Win',
    cardImage: '/scratchcard/scratch1.png',
    iconImage: '/scratchcard/scratch1.png',
  };

  scratchCards = [
    {
      ticketprice: 5,
      title: 'Diamond Rush',
      icon: 'https://cmax.pages.dev/assets/scratchcard/daimond.png',
      bgImage: '/scratch-neww.png',
      winning: '$200',
      treasure: '/Scratch-tresure.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 10,
      title: 'Gold Mania',
      icon: 'https://cmax.pages.dev/assets/scratchcard/fire.png',
      bgImage: '/scratch-neww.png',
      winning: '$300',
      treasure: '/Scratch-tresure.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 15,
      title: 'Treasure Hunt',
      icon: 'https://cmax.pages.dev/assets/scratchcard/crown.png',
      bgImage: '/scratch-neww.png',
      winning: '$400',
      treasure: '/Scratch-tresure.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 20,
      title: 'Diamond Rush',
      icon: 'https://cmax.pages.dev/assets/scratchcard/daimond.png',
      bgImage: '/scratch-neww.png',
      winning: '$500',
      treasure: '/Scratch-tresure.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 25,
      title: 'Gold Mania',
      icon: 'https://cmax.pages.dev/assets/scratchcard/fire.png',
      bgImage: '/scratch-neww.png',
      winning: '$1000',
      treasure: '/Scratch-tresure.png',
      buttonText: 'Buy Now!',
    },
    {
      ticketprice: 30,
      title: 'Treasure Hunt',
      icon: 'https://cmax.pages.dev/assets/scratchcard/crown.png',
      bgImage: '/scratch-neww.png',
      winning: '$2000',
      treasure: '/Scratch-tresure.png',
      buttonText: 'Buy Now!',
    },
  ];

  // Component.ts
  getRotation(index: number, length: number): number {
    // Adjust the spread angle as needed, e.g., -30° to +30°
    const maxAngle = 30;
    const startAngle = -maxAngle;
    const angleStep = (maxAngle * 2) / Math.max(length - 1, 1);
    return startAngle + angleStep * index;
  }

  private scrollToTopSmooth(): void {
    try {
      // Use smooth scrolling when supported
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      // Fallback for older browsers/environments
      try {
        window.scrollTo(0, 0);
      } catch {
        // ignore
      }
    }
  }
}
